import React from 'react';
import { Building2, Store, CirclePlus, TrendingUp } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';

export default function ClientAnalytics({ analytics }) {
    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 mb-4">
            <StatCard label="Total Clientes" value={formatNumber(analytics.totalClients)} icon={<Building2 />} tone="brand" hint="Clientes activos" />
            <StatCard label="Canal Moderno" value={formatNumber(analytics.modernoClients)} icon={<Store />} tone="info" hint="Grandes superficies" />
            <StatCard
                label="Canal Tradicional"
                value={formatNumber(analytics.tradicionalClients)}
                icon={<Store />}
                tone="warning"
                hint="Tiendas locales"
            />
            <StatCard
                label="Nuevos (30 días)"
                value={formatNumber(analytics.recentlyAdded || 0)}
                icon={<CirclePlus />}
                tone="violet"
                hint="Clientes agregados"
                trend={
                    analytics.recentlyAdded > 0 ? (
                        <span className="inline-flex items-center gap-1 text-success-fg">
                            <TrendingUp />
                            {`+${analytics.recentlyAdded}`}
                        </span>
                    ) : null
                }
            />
        </div>
    );
}
